// extracted by mini-css-extract-plugin
export default {"container":"speaker_container__Qt1M4","spekars":"speaker_spekars__FKzYS","one":"speaker_one__IKQ7F","two":"speaker_two__CB7Gm","hidden":"speaker_hidden__FLOQB"};